import React from "react";
import { Link } from "react-router-dom";

const AboutSection: React.FC = () => {
  return (
    <section className="section-padding bg-lounge-dark">
      <div className="container-custom">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Image column */}
          <div className="relative">
            <div className="relative h-[500px] rounded-lg overflow-hidden">
              <img 
                src="/assets/Company.jpeg" 
                alt="Seven8Nine Lounge Interior" 
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-lounge-dark to-transparent"></div>
            </div>
            <div className="absolute -bottom-4 -right-4 bg-lounge-gold px-6 py-4 rounded">
              <p className="font-display text-lounge-dark text-lg font-bold">EST. 2023</p>
            </div>
          </div>

          {/* Text column */}
          <div>
            <h2 className="section-title">Winnipeg's Most Luxurious Hookah Experience</h2>
            <p className="text-lounge-light/80 mb-6">
              At Seven8Nine Hookah Lounge, we don’t just serve hookah—we set the vibe.
            </p>
            <p className="text-lounge-light/80 mb-6">
              Located at the iconic intersection of Portage and Broadway in Winnipeg, Seven8Nine brings together culture, flavor, and energy in one unforgettable atmosphere.            
            </p>
            <p className="text-lounge-light/80 mb-8">
              Born from a vision to elevate the city’s nightlife, we offer a curated experience designed for those who value taste, sound, and ambiance:
              <ul className="list-disc list-inside text-lounge-light/80 mb-8">
                <li>Premium hookah blends infused with global flavor</li>
                <li>Handcrafted cocktails and exotic drink specials</li>
                <li>Live DJs, themed nights, and private events</li>
                <li>Three specialty chefs serving Caribbean, West African, and Indo-Chinese cuisine—all under one roof</li>
              </ul>
            </p>
            <p className="text-lounge-light/80 mb-6">
              Whether you’re winding down, celebrating, or hosting your own event, Seven8Nine surrounds you with luxury, culture, and next-level hospitality.
            </p>
            <p className="text-lounge-light/80 mb-6">
              Proudly built by the community we serve, our mission is simple:
              To be Winnipeg’s premier destination for connection, creativity, and elevated nightlife.
            </p>
            <Link to="/about" className="btn-primary">Learn More About Us</Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
